export const FETCH_LOCK_NUMBER = "FETCH_LOCK_NUMBER";
export const LIST_LOCK_NUMBER = "LIST_LOCK_NUMBER";
export const MODIFY_LOCK_NUMBER = "MODIFY_LOCK_NUMBER";


export const FETCH_LOCK_NUMBER_BY_USER = "FETCH_LOCK_NUMBER_BY_USER";
export const LIST_LOCK_NUMBER_BY_USER = "LIST_LOCK_NUMBER_BY_USER";
export const MODIFY_LOCK_NUMBER_BY_USER = "MODIFY_LOCK_NUMBER_BY_USER";
export const CLEAR_LIST_LOCK_NUMBER = "CLEAR_LIST_LOCK_NUMBER";

export const FETCH_BET_TEMPLATE = "FETCH_BET_TEMPLATE";
export const LIST_BET_TEMPLATE = "LIST_BET_TEMPLATE";
export const MODIFY_BET_TEMPLATE = "MODIFY_BET_TEMPLATE";
export const CLEAR_BET_TEMPLATE = "CLEAR_BET_TEMPLATE";

export const FETCH_HAS_LOTTERY_TEMPLATE = "FETCH_HAS_LOTTERY_TEMPLATE";
export const LIST_HAS_LOTTERY_TEMPLATE = "LIST_HAS_LOTTERY_TEMPLATE";
export const CREATE_HAS_LOTTERY_TEMPLATE = "CREATE_HAS_LOTTERY_TEMPLATE";
export const MODIFY_HAS_LOTTERY_TEMPLATE = "MODIFY_HAS_LOTTERY_TEMPLATE";
export const CLEAR_HAS_LOTTERY_TEMPLATE = "CLEAR_HAS_LOTTERY_TEMPLATE";